import { useContext } from 'react'
import * as DropdownMenu from '@radix-ui/react-dropdown-menu'

import { locales } from '../utils/locale'
import { LanguageContext } from './LanguageProvider'
import { HugeiconsIcon } from '@hugeicons/react'
import { Tick01Icon } from '@hugeicons/core-solid-rounded'

const languages = Object.entries(locales)

export function LanguageSwitcherMenuItem({ className }: { className: string }) {
  const { lang, onChange, flag, label } = useContext(LanguageContext)

  return (
    <DropdownMenu.Sub>
      <DropdownMenu.SubTrigger className={className}>
        <span>{flag}</span>
        <span>{label}</span>
      </DropdownMenu.SubTrigger>
      <DropdownMenu.Portal>
        <DropdownMenu.SubContent
          className="data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 flex flex-col gap-1 rounded-small bg-white p-3 shadow-md outline-hidden overflow-y-auto z-popover"
          sideOffset={2}
          alignOffset={-5}
        >
          {languages.map(function ([value, { flag, label }]) {
            const isSelected = lang === value

            return (
              <DropdownMenu.Item
                key={value}
                className={className}
                onSelect={() => onChange(value)}
              >
                <div className="size-4">
                  {isSelected ? (
                    <HugeiconsIcon icon={Tick01Icon} className="size-full" />
                  ) : null}
                </div>
                <span>{flag}</span>
                <span>{label}</span>
              </DropdownMenu.Item>
            )
          })}
        </DropdownMenu.SubContent>
      </DropdownMenu.Portal>
    </DropdownMenu.Sub>
  )
}
